/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getVehicleLeasePurchaseList: (params) => {
    return axios.get(API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  updateVehicleLeasePurchase: (id, data) => {
    let url = `${API_ENDPOINTS.GET_VEHICLE_LEASE_PURCHASES}/${id}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
